import { datadogLogs } from '@datadog/browser-logs';
import { env } from 'next-runtime-env';

import { SERVICE_NAME } from './constants';
import type { Level, Log } from './types';

const clientToken = 'pub85854dbdc3c1b30340b65a7b90e65420';

let initialized = false;

function init() {
	initialized = true;

	datadogLogs.init({
		clientToken,
		service: SERVICE_NAME,
		version: env('NEXT_PUBLIC_APP_VERSION'),
		forwardErrorsToLogs: true,
		sessionSampleRate: 100,
	});
}

export class Datadog {
	static log = (logLevel: Level, data: Log) => {
		if (!initialized) {
			init();
		}

		const payload = {
			service: data.service,
			hostname: data.product,
			status: logLevel,
			connectionEffectiveType: data.connectionEffectiveType,
			browser: data.browser,
			os: data.os,
			osVersion: data.osVersion,
			user: data.userId,
			...(data.fingerprint && { fingerprint: data.fingerprint }),
			...(data.payload && { payload: data.payload }),
		};

		datadogLogs.logger.log(data.message, payload, logLevel);
	};
}
